/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Show_In_FolderInputs */

const en_audio_embed_export_show_in_folder = /** @type {(inputs: Audio_Embed_Export_Show_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show in folder`)
};

const fr_audio_embed_export_show_in_folder = /** @type {(inputs: Audio_Embed_Export_Show_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher dans le dossier`)
};

const de_audio_embed_export_show_in_folder = /** @type {(inputs: Audio_Embed_Export_Show_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Ordner anzeigen`)
};

const it_audio_embed_export_show_in_folder = /** @type {(inputs: Audio_Embed_Export_Show_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra nella cartella`)
};

const ru_audio_embed_export_show_in_folder = /** @type {(inputs: Audio_Embed_Export_Show_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать в папке`)
};

const es_audio_embed_export_show_in_folder = /** @type {(inputs: Audio_Embed_Export_Show_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar en la carpeta`)
};

const zh_cn2_audio_embed_export_show_in_folder = /** @type {(inputs: Audio_Embed_Export_Show_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在文件夹中显示`)
};

const ja_audio_embed_export_show_in_folder = /** @type {(inputs: Audio_Embed_Export_Show_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダーに表示`)
};

const hi_audio_embed_export_show_in_folder = /** @type {(inputs: Audio_Embed_Export_Show_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर में दिखाओ`)
};

const pt_pt2_audio_embed_export_show_in_folder = /** @type {(inputs: Audio_Embed_Export_Show_In_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar na pasta`)
};

/**
* | output |
* | --- |
* | "Show in folder" |
*
* @param {Audio_Embed_Export_Show_In_FolderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_show_in_folder = /** @type {((inputs?: Audio_Embed_Export_Show_In_FolderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Show_In_FolderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_show_in_folder(inputs)
	if (locale === "de") return de_audio_embed_export_show_in_folder(inputs)
	if (locale === "it") return it_audio_embed_export_show_in_folder(inputs)
	if (locale === "ru") return ru_audio_embed_export_show_in_folder(inputs)
	if (locale === "es") return es_audio_embed_export_show_in_folder(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_show_in_folder(inputs)
	if (locale === "ja") return ja_audio_embed_export_show_in_folder(inputs)
	if (locale === "hi") return hi_audio_embed_export_show_in_folder(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_show_in_folder(inputs)
	return en_audio_embed_export_show_in_folder(inputs)
});